module.exports = __webpack_public_path__ + "img/phone-off.3c9f577b.svg";